var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRenameIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5937 6.875L11.25 4.53125L4.99997 10.7812V13.125H7.34372L13.5937 6.875ZM15.4437 5.025C15.6875 4.78125 15.6875 4.3875 15.4437 4.14375L13.9812 2.68125C13.8706 2.57065 13.7292 2.51024 13.5848 2.5H13.4964C13.352 2.51024 13.2106 2.57065 13.1 2.68125L11.875 3.90625L14.2187 6.25L15.4437 5.025ZM17.5 15H2.5V17.5H17.5V15Z",
    fill: "#3A4861"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRenameIcon);
export default __webpack_public_path__ + "static/media/rename-icon.2a7828bfaf35ae749a3cae8755925b12.svg";
export { ForwardRef as ReactComponent };